import { Button } from './button.tsx'

// RAL-214: a healthy account whose TikTok grant predates a scope Rally now requests. Not the
// degraded shell: publishing still works, so this only asks for a fresh consent. The backend
// re-authorizes the existing account in place, so /oauth/tiktok/connect is the whole flow. Any
// workspace admin can run it (RAL-80); a member gets the same notice without the action.
export function ReauthBanner({ missingScopes, canReconnect }: { missingScopes: string[]; canReconnect: boolean }) {
  if (missingScopes.length === 0) return null

  return (
    <div
      role="status"
      className="mb-6 flex flex-wrap items-center gap-3 rounded-md border border-signal-waiting-border bg-signal-waiting-bg px-4 py-3 text-sm text-signal-waiting"
    >
      <p className="min-w-0 flex-1">
        {canReconnect
          ? `TikTok needs you to re-authorize Rally for new permissions (${missingScopes.join(', ')}).`
          : `TikTok needs a workspace admin to re-authorize Rally for new permissions (${missingScopes.join(', ')}). Ask an admin to reconnect the channel.`}{' '}
        Publishing keeps running in the meantime.
      </p>
      {canReconnect ? (
        <Button as="a" href="/oauth/tiktok/connect" variant="secondary" size="sm">
          Re-authorize TikTok
        </Button>
      ) : null}
    </div>
  )
}
